import React from "react";
import classNames from "classnames";

import styles from "./ModalBackDrop.module.scss";

interface Props {
    active?: boolean;
    onClick?: () => void;
    className?: string;
}

const ModalBackDrop = ({ onClick, active = true, className }: Props) => {
    return (
        <div
            className={classNames(
                styles["modal-backdrop"],
                {
                    [styles["modal-backdrop--active"]]: active,
                },
                className,
            )}
            onClick={onClick}
            role="presentation"
        />
    );
};

export default ModalBackDrop;
